import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  ApproverSetPicker,
  ApproverSetPickerSchema,
  ApproverSetPickerValidation,
} from './ApproverSetPicker';

export const ApproverSetPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ApproverSetPicker',
    component: ApproverSetPicker,
    schema: ApproverSetPickerSchema,
    validation: ApproverSetPickerValidation,
  }),
);
